import {FACTURACION_TYPES} from '../constants/facturacion.types'
import {facturacionInitialState} from '../initital-state/facturacion.state'
import {Facturacion, FacturacionAction, FacturacionState} from '../interfaces/facturacion.interface'

const facturacionReducer = (
  state: Facturacion = facturacionInitialState,
  action: FacturacionAction
): FacturacionState => {
  switch (action.type) {
    case FACTURACION_TYPES.SET_CATALOGO_SUCURSAL:
      return {...state, catalogoSucursal: action.payload, sucursalesCargadas: true}
    case FACTURACION_TYPES.SET_CATALOGO_SERIE:
      return {...state, catalogoSerie: action.payload}
    case FACTURACION_TYPES.FORMCLIENTE_HANDLE_CHANGE:
      return {...state, formCliente: {...state.formCliente, ...action.payload}}
    case FACTURACION_TYPES.FORMCLIENTE_SET_ERRORS:
      return {...state, errorsFormCliente: {...state.errorsFormCliente, ...action.payload}}
    case FACTURACION_TYPES.FORMPRODUCTOS_HANDLE_CHANGE:
      return {...state, formProductos: {...state.formProductos, ...action.payload}}
    case FACTURACION_TYPES.FORMPRODUCTOS_SET_ERRORS:
      return {...state, errorsFormProductos: {...state.errorsFormProductos, ...action.payload}}
    case FACTURACION_TYPES.FORMPRODUCTOS_HANDLE_CHANGE_EDIT:
      return {...state, formProductosEdit: {...state.formProductosEdit, ...action.payload}}
    case FACTURACION_TYPES.FORMPRODUCTOS_SET_ERRORS_EDIT:
      return {
        ...state,
        errorsFormProductosEdit: {...state.errorsFormProductosEdit, ...action.payload},
      }
    case FACTURACION_TYPES.FORMSUCURSAL_HANDLE_CHANGE:
      return {...state, formSucursal: {...state.formSucursal, ...action.payload}}
    case FACTURACION_TYPES.FORMSUCURSAL_SET_ERRORS:
      return {...state, errorsFormSucursal: {...state.errorsFormSucursal, ...action.payload}}
    case FACTURACION_TYPES.FORMPRODUCTOS_CLEAR:
      return {
        ...state,
        formProductos: facturacionInitialState.formProductos,
        errorsFormProductos: facturacionInitialState.errorsFormProductos,
      }
    case FACTURACION_TYPES.ARRAYPRODUCTOS_ADD:
      return {
        ...state,
        arrayProductos: [...state.arrayProductos, action.payload],
      }
    case FACTURACION_TYPES.ARRAYPRODUCTOS_SET_DATA:
      return {
        ...state,
        arrayProductos: action.payload,
      }
    case FACTURACION_TYPES.ARRAYPRODUCTOS_EDIT:
      const array = state.arrayProductos.map((producto, i) =>
        i === state.productoSeleccionado ? state.formProductosEdit : producto
      )
      return {
        ...state,
        arrayProductos: array,
        modals: {...state.modals, activeEditar: false},
        formProductosEdit: facturacionInitialState.formProductosEdit,
        errorsFormProductosEdit: facturacionInitialState.errorsFormProductosEdit,
      }
    case FACTURACION_TYPES.FACT_DELETE_SERVICIOS:
      let prods = state.arrayProductos.filter((prods) => prods.tipo === "p")
      return {...state, arrayProductos: prods}
    case FACTURACION_TYPES.ARRAYPRODUCTOS_SELECT_ONE:
      return {...state, productoSeleccionado: action.payload}
    case FACTURACION_TYPES.ARRAYPRODUCTOS_DELETE_ONE:
      return {
        ...state,
        arrayProductos: [
          ...state.arrayProductos.filter((_, i) => i !== state.productoSeleccionado!),
        ],
      }
    case FACTURACION_TYPES.ARRAYPRODUCTOS_CLEAR_ALL:
      return {...state, arrayProductos: []}
    case FACTURACION_TYPES.ARRAYPRODUCTOS_SET_TOTAL_DOC_RELACIONADO:
      return {
        ...state,
        calculosArrayProductos: {...state.calculosArrayProductos, totalDocRelacionado: action.payload},
      }
    case FACTURACION_TYPES.ARRAYPRODUCTOS_SET_CALCULOS:
      return {
        ...state,
        calculosArrayProductos: {...state.calculosArrayProductos, ...action.payload},
      }
    case FACTURACION_TYPES.FACTURACION_CLEAR_ALL:
      let datosEmisor = !action.payload ? state.datosEmisor : {}
      return {...facturacionInitialState, datosEmisor}
    case FACTURACION_TYPES.SET_DATOS_EMISOR:
      return {...state, datosEmisor: {...state.datosEmisor, ...action.payload}}
    case FACTURACION_TYPES.SET_DATOS_FACTURA:
      return {...state, datosFacturaRes: {...state.datosFacturaRes, ...action.payload}}
    case FACTURACION_TYPES.SET_UUID:
      return {...state, datosUUID: {...state.datosUUID, ...action.payload}}
    case FACTURACION_TYPES.FACTURA_EMITIDA:
      return {...state, facturaEmitda: action.payload}
    case FACTURACION_TYPES.OPCIONES_ACTIVA:
      return {...state, opcionesActiva: true}
    case FACTURACION_TYPES.MODALELIMINAR_OPEN:
      return {...state, modals: {...state.modals, ...action.payload}}
    case FACTURACION_TYPES.MODALELIMINAR_CLOSE:
      return {...state, modals: facturacionInitialState.modals, productoSeleccionado: null}
    case FACTURACION_TYPES.MODALFACTURACION_OPEN:
      return {...state, modals: {...state.modals, ...action.payload}}
    case FACTURACION_TYPES.MODALEDITAR_OPEN:
      return {...state, modals: {...state.modals, activeEditar: true}, ...action.payload}
    case FACTURACION_TYPES.MODALEDITAR_CLOSE:
      return {
        ...state,
        modals: {...state.modals, activeEditar: false},
        formProductosEdit: facturacionInitialState.formProductosEdit,
        errorsFormProductosEdit: facturacionInitialState.errorsFormProductosEdit,
      }
    case FACTURACION_TYPES.MODALIMPRESION_OPEN:
      return {...state, modals: {...state.modals, activeImpresion: action.payload.modalFlag}, impresionModoTicket: action.payload.modoTicket}
    case FACTURACION_TYPES.MODALEMAIL_OPEN:
      return {...state, modals: {...state.modals, activeEmail: action.payload}}
    case FACTURACION_TYPES.MODALANULAR_OPEN:
      return {...state, modals: {...state.modals, activeAnular: action.payload}}
    case FACTURACION_TYPES.MODALCONFIRMARCLIENTEVACIO:
      return {...state, modals: {...state.modals, activeConfirmEmptyData: action.payload}}
    case FACTURACION_TYPES.FACTURACION_ANULADO:
      return {...state, anulado: action.payload}
    case FACTURACION_TYPES.MODAL_INFOCLIENTE_OPEN:
      return {...state, modals: {...state.modals, activeInfoCliente: action.payload}}
    case FACTURACION_TYPES.MODAL_INFOCLIENTE_CLOSE:
      return {...state, modals: {...state.modals, activeInfoCliente: action.payload}}
    case FACTURACION_TYPES.MODAL_SET_INFOCLIENTE:
      return {...state, modals: {...state.modals, infoCliente: action.payload}}
    default:
      return state
  }
}

export default facturacionReducer
